// import "./App.css";
import React from 'react';
import { Routes } from "./Routes";

export const App = () => {
  return <Routes />;
};

export default App;
